<template>
  <div
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <div v-if="!noBody" :class="bodyClasses">
      <slot />
    </div>
    <slot v-else />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdCard',

  inheritAttrs: false,

  props: {
    borderVariant: {
      type: String,
      default: null
    },
    bgVariant: {
      type: String,
      default: null
    },
    textVariant: {
      type: String,
      default: null
    },
    bodyClass: {
      type: [String, Array, Object],
      default: null
    },
    noBody: {
      type: Boolean,
      default: false
    }
  },

  emits: [],

  computed: {
    cardClasses() {
      const classes = ['card'];

      if (this.borderVariant) {
        classes.push('border');
        classes.push(`border-${this.borderVariant}`);
      }
      if (this.bgVariant) classes.push(`bg-${this.bgVariant}`);
      if (this.textVariant) classes.push(`text-${this.textVariant}`);

      return classes;
    },

    bodyClasses() {
      return ['card-body', this.bodyClass].flat().filter(Boolean);
    },

    mergedClasses() {
      return [this.$attrs.class, this.cardClasses].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
